import { getNarrative, GQLGetNarrativeResponse } from 'graphql/narrative/queries';
import { UseQueryOptions, useQuery } from 'react-query';

type Params = {
  orderId: string;
  queryConfig?: UseQueryOptions<GQLGetNarrativeResponse, Error, GQLGetNarrativeResponse, any>;
};

export const useGetOrderNarrative = ({ orderId, queryConfig }: Params) =>
  useQuery(['order-narrative', { orderId }], () => getNarrative({ orderId }), {
    ...queryConfig,
    enabled: !!orderId && queryConfig?.enabled !== false,
    refetchOnWindowFocus: false,
  });
